module.exports = __webpack_public_path__ + "img/Liputan-Image-3.03323101.png";